import { useQuery } from "@tanstack/react-query";

import * as v3Adapter from "./adapter/v3";
import { resourceQueryOptions } from "./api/resource-query-options";

export function useResource(resourceId: string | undefined, enabled = true) {
  return useQuery({
    ...resourceQueryOptions.byId(resourceId || ""),
    enabled: enabled && !!resourceId,
    select: (v3Dto) => v3Adapter.toResource(v3Dto),
  });
}
